import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import * as UserActionCreators from "../../../../actions/user.actions";
import { IAppState } from '../../../../app';
import RegisterForm from '../../../Users/RegisterForm';
import { IRegisterFormItem } from '../../../Users/RegisterForm';
import { IHiddenFieldOption } from '../../Configuration/Platypus/PageGroups';

interface IPageRegisterProps {
    formItems: IRegisterFormItem[];
    hiddenFieldModel?: string;
    hiddenFieldOptions?: IHiddenFieldOption[];
    registeringAccount: boolean;
    title: string;
    userAgreementTerms: any;
    userAgreementCheckboxText: string;

    registerUser: typeof UserActionCreators.registerUser;
}

interface IPageRegisterRouteParams {
}

interface IPageRegisterQueryParams {
    hf: string;
}

type PageRegisterProps = IBasePageProps<IPageRegisterRouteParams, IPageRegisterQueryParams> & IPageRegisterProps;

class PageRegister extends React.Component<PageRegisterProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {

        return (
            <div className="p-4 col-12">
                <h3>{this.props.title}</h3>
                <RegisterForm
                    registerUser={this.props.registerUser}
                    className="col-lg-6 col-12 border-md-right"
                    registering={this.props.registeringAccount}
                    formItemClassName="form-control-sm mb-2"
                    formItems={this.props.formItems}
                    hiddenFieldModel={this.props.hiddenFieldModel ? this.props.hiddenFieldModel : undefined}
                    hiddenFieldValue={this.props.queryParams.hf && this.props.hiddenFieldOptions ? this.props.hiddenFieldOptions.find(f => f.value == Number(this.props.queryParams.hf)).dbValue : undefined}
                    userAgreementTerms={this.props.userAgreementTerms}
                    userAgreementCheckboxText={this.props.userAgreementCheckboxText}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageRegisterProps) => {

    return {
        registeringAccount: state.user.registeringAccount
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        registerUser: UserActionCreators.registerUser,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageRegister);